import FadeIn from '../components/FadeIn';
import { SERVICES, WA_URL } from '../data/constants';

export default function Servicios() {
  return (
    <section className="sec sec-warm" style={{ paddingTop: 108 }}>
      <FadeIn>
        <div className="sec-tag">Portafolio completo</div>
        <h2 className="sec-title">Servicios especializados</h2>
        <p className="sec-sub">
          Cobertura técnica integral para todos los componentes de tu estación de servicio.
        </p>
      </FadeIn>

      <div className="svc-grid">
        {SERVICES.map((s, i) => (
          <FadeIn key={s.name} delay={i * 40}>
            <div className="svc-card" style={{ cursor: 'default' }}>
              <div className="svc-icon">{s.icon}</div>
              <div className="svc-num">{String(i + 1).padStart(2, '0')}</div>
              <div className="svc-name">{s.name}</div>
              <p className="svc-desc">{s.desc}</p>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={240}>
        <div style={{ background: '#1C2B3A', padding: '36px 40px', marginTop: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20, borderTop: '3px solid #D4600A' }}>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.2em', textTransform: 'uppercase', color: '#D4600A', marginBottom: 8 }}>
              ¿Servicio a medida?
            </div>
            <h3 style={{ fontFamily: "'Merriweather',serif", fontSize: 24, fontWeight: 900, color: '#FFFFFF' }}>
              Hablemos de tu proyecto
            </h3>
          </div>
          <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn btn-fuel btn-sm">
            WhatsApp ↗
          </a>
        </div>
      </FadeIn>
    </section>
  );
}
